import { InjectionToken } from '@angular/core';
import { AnnotationRow } from '../domain/types';

/** Synchronous crash-cache for in-progress annotation work. */
export interface AnnotationDraftCache {
  read(documentId: string): AnnotationRow[] | null;
  write(documentId: string, rows: readonly AnnotationRow[]): void;
  clear(documentId: string): void;
}

export const ANNOTATION_DRAFT_CACHE = new InjectionToken<AnnotationDraftCache>(
  'ANNOTATION_DRAFT_CACHE',
);
